export const safeStringToNumber = (str) => {
    const num = Number(str);
    if (isNaN(num))
        return 0;
    return num;
};
//# sourceMappingURL=safe-string-to-number.js.map